import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FinchButton  from './FinchButton';
import urlHandler from '../../utils/urlHandler';
import settings from '../../utils/settings';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

class TagControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    render() {
        return(
            <div className="tagcontrol-wrapper">
                <div>
                    <div className="toolbar-container">
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onReset}>
                            <span className='fa fa-undo'></span>&nbsp;Reset
                        </button>
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onEdit}>
                            <span className='fa fa-edit'></span>&nbsp;Edit
                        </button>
                    </div>
                    <div className="tag-text form-field-wrapper">
                        <div className='header'>Original Text:</div>
                        <div style={{whiteSpace: 'pre-line'}}>
                            {this.props.text}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

TagControl.propTypes = {
    text: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired
};

export default TagControl;

